var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/award"
  }, /*#__PURE__*/React.createElement("g", {
    id: "award"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M26.9234 11.9599L26.7134 11.8399L24.6284 10.6399L20.3234 8.14992C19.0034 7.38492 16.9934 7.38492 15.6734 8.14992L11.3684 10.6399L9.28344 11.8549L9.01344 12.0049C6.32844 13.8049 6.14844 14.1349 6.14844 17.0299V23.9449C6.14844 26.8399 6.32844 27.1699 9.07344 29.0149L15.6734 32.8249C16.3334 33.2149 17.1584 33.3949 17.9984 33.3949C18.8234 33.3949 19.6634 33.2149 20.3234 32.8249L26.9834 28.9699C29.6684 27.1699 29.8484 26.8399 29.8484 23.9449V17.0299C29.8484 14.1349 29.6684 13.8049 26.9234 11.9599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.28125 11.8545L11.3662 10.6395L15.4762 8.26953L15.6712 8.14953C16.9912 7.38453 19.0013 7.38453 20.3212 8.14953L20.5163 8.26953L24.6262 10.6395L26.7112 11.8395V8.62953C26.7112 5.25453 24.8512 3.39453 21.4762 3.39453H14.5013C11.1263 3.39453 9.28125 5.25453 9.28125 8.62953V11.8545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.2577 20.4045L21.3277 21.5445C21.1777 21.7095 21.0727 22.0395 21.0877 22.2645L21.1777 23.7345C21.2377 24.6345 20.5927 25.0995 19.7527 24.7695L18.3877 24.2295C18.1777 24.1545 17.8177 24.1545 17.6077 24.2295L16.2427 24.7695C15.4027 25.0995 14.7577 24.6345 14.8177 23.7345L14.9077 22.2645C14.9227 22.0395 14.8177 21.7095 14.6677 21.5445L13.7377 20.4045C13.1527 19.7145 13.4077 18.9495 14.2777 18.7245L15.7027 18.3645C15.9277 18.3045 16.1977 18.0945 16.3177 17.8995L17.1127 16.6695C17.6077 15.9045 18.3877 15.9045 18.8827 16.6695L19.6777 17.8995C19.7977 18.0945 20.0677 18.3045 20.2927 18.3645L21.7177 18.7245C22.5877 18.9495 22.8427 19.7145 22.2577 20.4045Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.99e5f0ce4162098d29debc6255f5351a.svg";
export { ForwardRef as ReactComponent };